var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:Inter-Black;src:url(" + escape(require("../font/Inter-woff2/Inter-Black.woff2")) + ") format(\"woff2\")}@font-face{font-family:Inter-Bold;src:url(" + escape(require("../font/Inter-woff2/Inter-Bold.woff2")) + ") format(\"woff2\")}@font-face{font-family:Inter-Regular;src:url(" + escape(require("../font/Inter-woff2/Inter-Regular.woff2")) + ") format(\"woff2\")}@font-face{font-family:Inter-Medium;src:url(" + escape(require("../font/Inter-woff2/Inter-Medium.woff2")) + ") format(\"woff2\")}.inter-black{font-family:Inter-Black}.inter-bold{font-family:Inter-Bold}.inter-regular{font-family:Inter-Regular}.inter-medium{font-family:Inter-Medium}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/assets/styles/font-family.css
// module id = 528
// module chunks = 309